var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExclamationSign = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_8237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 9.99984C1.66667 12.21 2.54465 14.3296 4.10745 15.8924C5.67025 17.4552 7.78987 18.3332 10 18.3332C12.2101 18.3332 14.3298 17.4552 15.8926 15.8924C17.4554 14.3296 18.3333 12.21 18.3333 9.99984C18.3333 7.7897 17.4554 5.67008 15.8926 4.10728C14.3298 2.54448 12.2101 1.6665 10 1.6665C7.78987 1.6665 5.67025 2.54448 4.10745 4.10728C2.54465 5.67008 1.66667 7.7897 1.66667 9.99984V9.99984Z",
    stroke: "#F53C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5127V9.35885",
    stroke: "#F53C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35898 13.205C9.35898 13.375 9.42651 13.538 9.54673 13.6583C9.66695 13.7785 9.82999 13.846 10 13.846C10.17 13.846 10.3331 13.7785 10.4533 13.6583C10.5735 13.538 10.641 13.375 10.641 13.205C10.641 13.035 10.5735 12.8719 10.4533 12.7517C10.3331 12.6315 10.17 12.564 10 12.564C9.82999 12.564 9.66695 12.6315 9.54673 12.7517C9.42651 12.8719 9.35898 13.035 9.35898 13.205Z",
    stroke: "#F53C5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_8237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExclamationSign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exclamationSign.4cc01187.svg";
export { ForwardRef as ReactComponent };